import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          {/* Brand */}
          <div className="footer-brand">
            <Link to="/" className="footer-logo">
              <div className="footer-logo-icon">💰</div>
              <div>
                <strong>A-Mobile Tax</strong>
                <span>Services</span>
              </div>
            </Link>
            <p>Fast, accurate, and secure tax filing for individuals, families, and businesses across all 50 states. We maximize your refund every time.</p>
            <div className="footer-tagline">
              "We Don't Just File Taxes — We Maximize Your Refund"
            </div>
            <div className="footer-social">
              <a href="#facebook" className="social-btn" aria-label="Facebook">📘</a>
              <a href="#instagram" className="social-btn" aria-label="Instagram">📸</a>
              <a href="https://wa.me/12244154202" target="_blank" rel="noreferrer" className="social-btn" aria-label="WhatsApp">💬</a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-col">
            <h4>Quick Links</h4>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
              <li><Link to="/privacy">Privacy Policy</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div className="footer-col">
            <h4>Services</h4>
            <ul className="footer-links">
              <li><Link to="/services">W2 Tax Filing</Link></li>
              <li><Link to="/services">Self-Employed / 1099</Link></li>
              <li><Link to="/services">Business Tax (LLC)</Link></li>
              <li><Link to="/services">Trucking Taxes</Link></li>
              <li><Link to="/services">IRS Letter Help</Link></li>
              <li><Link to="/services">ITIN Applications</Link></li>
              <li><Link to="/services">Tax Planning</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="footer-col">
            <h4>Contact Us</h4>
            <ul className="footer-contact">
              <li>
                <span>📍</span>
                <span>2033 Dodge Ave,<br />Evanston, IL 60201</span>
              </li>
              <li>
                <span>📞</span>
                <a href="tel:+12244154202">224-415-4202</a>
              </li>
              <li>
                <span>📧</span>
                <a href="mailto:info@amobiletax.com">info@amobiletax.com</a>
              </li>
              <li>
                <span>🕐</span>
                <span>Mon–Sat: 9AM–7PM</span>
              </li>
            </ul>
            <a
              href="https://wa.me/12244154202"
              target="_blank"
              rel="noreferrer"
              className="btn btn-whatsapp footer-wa"
            >
              💬 WhatsApp Us Now
            </a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <p>© {year} A-Mobile Tax Services. All Rights Reserved.</p>
          <p className="footer-disclaimer">
            A-Mobile Tax Services is not a law firm. Tax outcomes may vary based on individual circumstances.
            We comply with all IRS regulations and due diligence requirements.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
